import { render } from "./JSONVisualization.vue?vue&type=template&id=2cfe74ac"
import script from "./JSONVisualization.vue?vue&type=script&lang=js"
export * from "./JSONVisualization.vue?vue&type=script&lang=js"

import "./JSONVisualization.vue?vue&type=style&index=0&id=2cfe74ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__